import { X, Check } from 'lucide-react';

export function UnitConversionModal({ isOpen, onClose, currentUnit, onUnitChange }) {
  if (!isOpen) return null;

  const handleUnitSelect = (unit) => {
    onUnitChange(unit);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/10 flex items-end justify-center z-50">
      {/* Modal Sheet */}
      <div className="bg-card text-foreground rounded-t-3xl w-full max-w-md shadow-2xl animate-slide-up">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-[var(--border)]">
          <h2 className="text-xl">Convert Units</h2>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-full bg-muted flex items-center justify-center hover:bg-[color-mix(in srgb,var(--muted) 85%, var(--foreground) 15%)] transition-colors"
            aria-label="Close"
          >
            <X className="w-5 h-5 text-muted-foreground" />
          </button>
        </div>

        {/* Options */}
        <div className="p-4 pb-8">
          <p className="text-sm text-muted-foreground mb-4 px-2">
            Choose your preferred measurement system
          </p>

          {/* Metric Option */}
          <button
            onClick={() => handleUnitSelect('metric')}
            className={`w-full flex items-center justify-between p-4 rounded-2xl transition-colors mb-3 ${
              currentUnit === 'metric'
                ? 'bg-[var(--accent)]/15 border-2 border-accent'
                : 'bg-muted border-2 border-transparent hover:bg-[color-mix(in srgb,var(--muted) 85%, var(--foreground) 15%)]'
            }`}
          >
            <div className="flex-1 text-left">
              <div className="font-medium text-foreground">Metric</div>
              <div className="text-sm text-muted-foreground">Grams, Litres, Celsius</div>
            </div>
            {currentUnit === 'metric' && (
              <div className="w-6 h-6 rounded-full bg-accent flex items-center justify-center flex-shrink-0">
                <Check className="w-4 h-4 text-white" />
              </div>
            )}
          </button>

          {/* Imperial Option */}
          <button
            onClick={() => handleUnitSelect('imperial')}
            className={`w-full flex items-center justify-between p-4 rounded-2xl transition-colors ${
              currentUnit === 'imperial'
                ? 'bg-[var(--accent)]/15 border-2 border-accent'
                : 'bg-muted border-2 border-transparent hover:bg-[color-mix(in srgb,var(--muted) 85%, var(--foreground) 15%)]'
            }`}
          >
            <div className="flex-1 text-left">
              <div className="text-foreground mb-1">Imperial</div>
              <div className="text-sm text-muted-foreground">Pounds, Ounces, Fahrenheit</div>
            </div>
            {currentUnit === 'imperial' && (
              <div className="w-6 h-6 rounded-full bg-accent flex items-center justify-center flex-shrink-0">
                <Check className="w-4 h-4 text-white" />
              </div>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
